export function formatNumberWithSpaces(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  const numStr = String(value).replace(/\s/g, '');
  if (!numStr || isNaN(Number(numStr))) return '';
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function parseFormattedNumber(formattedValue: string): string {
  if (!formattedValue) return '';
  return formattedValue.replace(/\s/g, '');
}

export function formatSalaryDisplay(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '';
  const num = typeof value === 'number' ? value : parseInt(String(value).replace(/\s/g, ''), 10);
  if (isNaN(num)) return '';
  return num.toLocaleString('ru-RU').replace(/,/g, ' ').replace(/\./g, ' ');
}

